import { render, staticRenderFns } from "./login-main-mobile.vue?vue&type=template&id=09d209a5&scoped=true";
import script from "./login-main-mobile.vue?vue&type=script&lang=js";
export * from "./login-main-mobile.vue?vue&type=script&lang=js";
import style0 from "./login-main-mobile.vue?vue&type=style&index=0&id=09d209a5&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "09d209a5", null);
export default component.exports;